import { API_SCOPE, AZURE_CLIENT_ID } from '../config/env';

const NULLISH_STORAGE_VALUES = new Set(['null', 'undefined']);

const normalizeForComparison = (value: string): string => {
  const normalized = value.trim().toLowerCase();
  const apiScopeMatch = normalized.match(/^api:\/\/([^/]+)(?:\/.*)?$/);
  return apiScopeMatch?.[1] ?? normalized;
};

export const getReservedInstitutionContextIds = (): string[] =>
  [AZURE_CLIENT_ID, API_SCOPE].filter((value): value is string => Boolean(value?.trim()));

export const normalizeInstitutionContextId = (
  value: string | null | undefined,
  reservedIds: string[] = getReservedInstitutionContextIds(),
): string | null => {
  const normalized = value?.trim();
  if (!normalized || NULLISH_STORAGE_VALUES.has(normalized.toLowerCase())) {
    return null;
  }

  const candidate = normalizeForComparison(normalized);
  const reserved = new Set(
    reservedIds
      .map((reservedId) => reservedId.trim())
      .filter(Boolean)
      .map(normalizeForComparison),
  );

  if (reserved.has(candidate)) {
    return null;
  }

  return normalized;
};

export const readStoredInstitutionContextId = (
  key: string,
  reservedIds?: string[],
): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const rawValue = sessionStorage.getItem(key);
  const normalized = normalizeInstitutionContextId(rawValue, reservedIds);
  if (rawValue && !normalized) {
    sessionStorage.removeItem(key);
  }

  return normalized;
};

export const writeStoredInstitutionContextId = (
  key: string,
  value: string | null | undefined,
  reservedIds?: string[],
): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const normalized = normalizeInstitutionContextId(value, reservedIds);
  if (normalized) {
    sessionStorage.setItem(key, normalized);
    return normalized;
  }

  sessionStorage.removeItem(key);
  return null;
};
